import { render, staticRenderFns } from "./duDocument.vue?vue&type=template&id=3626f2b9&"
import script from "./duDocument.vue?vue&type=script&lang=js&"
export * from "./duDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports